"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalDividerBase = void 0;
var React = require("react");
var Utilities_1 = require("../../Utilities");
var getClassNames = (0, Utilities_1.classNamesFunction)();
exports.VerticalDividerBase = React.forwardRef(function (props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var styles = props.styles, theme = props.theme, deprecatedGetClassNames = props.getClassNames, className = props.className;
    var classNames = getClassNames(styles, { theme: theme, getClassNames: deprecatedGetClassNames, className: className });
    return (React.createElement("span", { className: classNames.wrapper, ref: ref },
        React.createElement("span", { className: classNames.divider })));
});
exports.VerticalDividerBase.displayName = 'VerticalDividerBase';
//# sourceMappingURL=VerticalDivider.base.js.map